export default __webpack_public_path__ + "745f088.png";